var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.6667 7H21.68M7.66667 1H21C24.6819 1 27.6667 3.98477 27.6667 7.66667V21C27.6667 24.6819 24.6819 27.6667 21 27.6667H7.66667C3.98477 27.6667 1 24.6819 1 21V7.66667C1 3.98477 3.98477 1 7.66667 1ZM19.6667 13.4933C19.8312 14.603 19.6417 15.7363 19.125 16.732C18.6083 17.7278 17.7909 18.5352 16.7888 19.0396C15.7868 19.5439 14.6513 19.7195 13.5437 19.5412C12.4362 19.363 11.413 18.8401 10.6198 18.0469C9.82656 17.2537 9.30364 16.2305 9.12542 15.123C8.9472 14.0154 9.12275 12.8799 9.6271 11.8778C10.1315 10.8758 10.9389 10.0583 11.9346 9.54166C12.9304 9.02499 14.0637 8.83545 15.1733 9C16.3052 9.16785 17.3531 9.69528 18.1623 10.5044C18.9714 11.3135 19.4988 12.3614 19.6667 13.4933Z",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.78fddefc7f5e0e4b9a4ecb1e8f24c09f.svg";
export { ForwardRef as ReactComponent };